import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Route } from 'react-router-dom'
import {Flex} from "../components/layout"
import MaterialsGrid from '../components/MaterialsGrid'
import MaterialsGridMobile from '../components/mobile_MaterialsGrid'
import Filters from '../components/_Filters'
import MaterialsKind from '../components/MaterialsKind'
import Superface from '../Superface'
// import { isTabletOrMobile } from '../kit';
// import * as kit from '../kit'

class Materials extends React.Component{

    componentWillUnmount(){
        if(this.timeoutMount) clearTimeout(this.timeoutMount)
    }

    componentWillMount(){
        document.title = Superface.translate('Matières') + ' - Superface'
        this.setState({
            ...this.state,
            mounted : false
        })
    }

    componentDidMount(){
        Superface.setCompass('W')
        this.checkMaterialGridActivation(this.props.location.pathname)
        this.timeoutMount = setTimeout(() => {
           this.setState({...this.state, mounted : true})
        }, 1000);
    }

    componentWillReceiveProps(new_props){

        if( new_props.location.pathname !== this.props.location.pathname ){
            this.checkMaterialGridActivation(new_props.location.pathname)
        }
    }

    checkMaterialGridActivation(path){
        
        if( this.props.isOnSingle ){
            Superface.disableMaterialsGrid()
        }else{
            Superface.enableMaterialsGrid()
        }
    }

    renderKinds(){
        if( !Superface.IS_MOBILE_OR_TABLET ) return <Filters  type="kind" filters={this.props.kindsFilters} />
    }

    renderKindTitle(){
        if( !this.props.isOnSingle && !Superface.IS_MOBILE ){
            return <div id="kind-title" className={ this.props.kindTitle === '' ? '' : 'show' } style={{position:'absolute', zIndex:'940', top:'4.2rem',left:'50%', width:'300px', marginLeft:'-150px',textAlign:'center', pointerEvents:'none'}}>{this.props.kindTitle}</div>
        }
    }   

    renderGrid(){
        
        if( Superface.IS_MOBILE ){
            return(
                <MaterialsGridMobile 
                    materials={this.props.materials}
                    materialsImagesLoaded={this.props.materialsImagesLoaded}
                    />
            )
        }else{
            return(
                <MaterialsGrid 
                    kindsFilters={this.props.kindsFilters} 
                    materials={this.props.materials}
                    active={this.props.materialsGridActive}
                    isOnSingle={this.props.isOnSingle}
                    materialsImagesLoaded={this.props.materialsImagesLoaded}
                    />
            )
        }
    }

    render(){
        // console.log(  )
        return(
            <div 
                id="materials" 
                className={((this.state.mounted)  ? 'mounted' : '') + (this.props.mapLeaving ? ' leave' : '')} 
                style={{overflow:'hidden', width:'100%', height:'100%', backgroundColor:'white', cursor:this.props.cursor}}
                >
                           
                <Flex  align='center' justify='center' style={{backgroundColor:'white', width:'100%', height:'100%'}}>
                    
                    <Route path={ Superface.uri('matieres') + '/:slug'} render={
                        (props) => {
                            return(
                                <MaterialsKind 
                                    kinds={this.props.materialsKinds} 
                                    featuredImage={this.props.kindFeaturedImagePath} 
                                    singleLeaving={this.props.singleLeaving}
                                    />
                            )
                        }
                    }/>
                    
                    {this.renderKindTitle()}
                    
                    {this.renderGrid()}
                    
                    {this.renderKinds()}
                    
                </Flex>
                           
                   
            </div>
        )
    }
}


const mapStateToProps = (state, ownProps) => {
    // console.log('featured image : ' + state.app.kindFeaturedImagePath)
	return {
        singleLeaving : state.app.singleLeaving,
        mapLeaving : state.app.mapLeaving,
        kindsFilters : state.app.kindsFilters,
        materialsGridActive : !state.app.isOnSingle,
        materials : state.data.materials,
        materialsImagesLoaded : state.data.materialsImagesLoaded,
        materialsKinds : state.data.materialsKinds,
        kindTitle : state.app.kindTitle,
        entry : state.app.entry,
        cursor:state.app.cursor,
        kindFeaturedImagePath : state.app.kindFeaturedImagePath,
        isOnSingle : state.app.isOnSingle
	}
}

export default withRouter(connect(
	mapStateToProps,
    null
)(Materials))



// WEBPACK FOOTER //
// ./src/containers/Materials.js